<template>
  <div class="media_main">
    <!-- 左侧列表 媒体列表-->
    <div class="media_left">
      <ul class="left_child">
        <li :class="activeName===item.site?'active':''" v-for="(item,idx) in siteData" :key="idx" @click="clickMedia(item.site)">{{ item.site }}（{{ item.count }}）</li>
      </ul>
    </div>
    <!-- 右侧内容 -->
    <div class="media_right">
      <div class="back">
        <span class="back_txt" @click="goBack">Back</span>
      </div>
      <div class="top_list">
        <span v-if="emotionData.emotionPositiveCount">
          正面（{{ emotionData.emotionPositiveCount }}）
        </span>
        <span v-if="emotionData.emotionNeutralCount">
          中性（{{ emotionData.emotionNeutralCount }}）
        </span>
        <span v-if="emotionData.emotionNegativeCount">
          负面（{{ emotionData.emotionNegativeCount }}）
        </span>
      </div>
      <div class="cont_list">
        <div class="data_list" v-if="newsData && newsData.length > 0">
          <div class="news" v-for="(item, index) of newsData" :key="index">
            <!-- 品牌logo -->
            <div class="news_img">
              <div class="img_container">
                <img :src="item.logo" />
              </div>
            </div>
            <div class="news_content">
              <!-- 新闻标题 -->
              <div
                class="title text_one_line"
                @click="newContentDetail(item)"
                v-html="item.title"
              >
                {{ item.title }}
              </div>
              <!-- 新闻摘要 -->
              <div class="detail text_two_line" v-html="item.summary">
                {{ item.summary }}
              </div>
              <div class="other_infor">
                <!-- 发布媒体 -->
                <div class="new_author">
                  <span class="item_title">Source:</span>
                  <span class="item_detail">
                    {{ item.site || 'None'}}
                  </span>
                </div>
                <!-- 发布时间 -->
                <div class="new_from">
                  <span class="item_title">Release time:</span>
                  <span class="item_detail color_alone">
                    {{ item.publish }}
                  </span>
                </div>
                <!-- 所属国家 -->
                <div class="new_time">
                  <span class="item_title">{{ item.countryEN || 'None'}}</span>
                </div>
                <!-- 情感 -->
                <div class="new_time judge_btn">
                  <span class="show_btn">{{ item.emotion }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { brandSiteStatistics } from "@/common/js/http/version3Api.js";
export default {
  data() {
    return {
      siteData: [],
      newsData: [],
      emotionData: {},
      isBack: true,
      currentPage: 1,
      pageSize: 5,
      totalNum: 0, //总页数为100
      activeName:null
    };
  },
  created() {
    this.getMediaList();
  },
  methods: {
    // 分页显示
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMediaList(this.activeName)
    },
    async getMediaList(param) {
      const site = param ? param : this.$route.query.site
      const form = {
        companyId: this.$route.query.companyId,
        emotion: this.$route.query.emotion,
        region: this.$route.query.region,
        country: this.$route.query.country,
        site,
        startTime: this.$route.query.startTime,
        endTime: this.$route.query.endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      const res = await brandSiteStatistics(form);
      if (res.code === 200) {
        this.emotionData = res.result.emotionMap;
        this.siteData = param ? this.siteData : res.result.siteList;
        this.newsData = res.result.newsMap.newsList;
        this.totalNum = res.result.newsMap.totals;
        this.pageSize = res.result.newsMap.pageSize;
        // 这里是初始值
        this.activeName = !param && this.siteData.length > 0 ? this.siteData[0].site : this.activeName;
      }
    },
    newContentDetail(row) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          isBack: this.isBack,
          id: row.id,
          companyId: this.$route.query.companyId,
          emotion: this.$route.query.emotion,
          site: this.$route.query.site,
          topNum: row.topNum
        },
      });
    },
    async clickMedia(media) {
      this.activeName = media;
      this.currentPage = 1;
      const form = {
        companyId: this.$route.query.companyId,
        emotion: this.$route.query.emotion,
        region: this.$route.query.region,
        country: this.$route.query.country,
        site: media,
        startTime: this.$route.query.startTime,
        endTime: this.$route.query.endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      const res = await brandSiteStatistics(form);
      if (res.code === 200) {
        this.emotionData = res.result.emotionMap;
        // this.siteData = res.result.siteList;
        this.newsData = res.result.newsMap.newsList;
        this.totalNum = res.result.newsMap.totals
        this.pageSize = res.result.newsMap.pageSize
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        name: "BrandCensus",
      });
    },
  },
};
</script>

<style scoped>
.media_main {
  width: 100%;
  height: 100%;
  padding: 10px;
  overflow: hidden;
}
.media_left {
  width: 30%;
  height: 100%;
  float: left;
  border-right: 2px solid #ccc;
  overflow-y: auto;
}
.media_left::-webkit-scrollbar,
.media_right::-webkit-scrollbar {
  display: none;
}
.media_left .left_child {
  height: auto;
}
.left_child li {
  padding: 10px;
  background:#fff;
  margin-bottom: 10px;
  cursor: pointer;
}
.left_child li.active {
  background-color:#208EFF;
  color: white;
  border-bottom:none;
}
.media_right {
  width: calc(100% - 30%);
  height: 100%;
  float: right;
  padding: 0 10px;
  overflow-y: auto;
}
.media_right .top_list {
  width: 100%;
  height: 20px;
  margin: 10px 0;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom;
}
.describe {
  padding: 0 5px;
}
.media_right .cont_list {
  /* height: calc(100% - 30px); */
  margin-bottom: 10px;
}
.data_list >>> .el-pagination {
  margin: 0 auto;
  text-align: center;
}
.news_source >>> .el-select > .el-input {
  width: 150px !important;
}
.date_search >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px !important;
}
.date_search >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.news {
  height: 168px;
  border-bottom: 1px solid #f3f4f5;
}

.news > div {
  display: inline-block;
  vertical-align: top;
}

.news_img {
  width: 145px;
  margin: 30px 0 15px;
  text-align: center;
}

.news_content {
  padding-top: 27px;
  width: calc(100% - 145px);
}

.img_container {
  width: 120px;
  height: 78px;
  line-height: 73px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.img_container img {
  max-width: 100%;
}

.news .news_content .title {
  font-size: 18px;
  color: #9ca2b3;
  font-family: RCB;
  margin-bottom: 15px;
  cursor: pointer;
}

.news .news_content .title:hover {
  color: #4e5671;
}

.news .color_alone {
  color: #1a6bc5;
  font-family: RCR;
}
.item_detail {
  font-family: RCR;
  padding-right: 10px;
}
.news .news_content .detail {
  font-size: 13px;
  color: #6c757d;
  line-height: 20px;
  margin-bottom: 15px;
  font-family: RCR;
}
.other_infor > div {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  color: #6c757d;
}
/* .judge_btn {
  width: 40%;
  text-align: right;
} */
.show_btn {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 1px 10px;
  border-radius: 7px;
  font-size: 10px;
}
.news_time {
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom;
}
.item_title {
  display: inline-block;
  font-size: 14px;
  color: #4e5671;
  font-family: RCB;
  margin-right: 10px;
}

.back {
  flex: 1;
  text-align: right;
  line-height: 26px;
}

.back_txt {
  padding: 5px 15px;
  border-radius: 15px;
  color: #8590a6;
  background: #f2f3f4;
  border: 1px solid rgba(0, 0, 0, 0);
  font-family: RCR;
  text-align: center;
  cursor: pointer;
}
</style>
